<template>
  <!-- 覆盖区域 -->
  <div class="fugaiswipermain-mb">
    <swiper ref="mySwiper" :options="swiperOption">
      <!-- slides -->
      <swiper-slide class="swiper-slide-mb" v-for="(item,index) in fugaiswipered" :key="index">
        <div class="bg_main" @mouseenter="on_bot_enter" @mouseleave="on_bot_leave" :style="{background:'url('+item.pic+') no-repeat'}">
          <div class="swiper-address-mb">
            <span class="swiper-province">{{item.province}}</span>
            <p class="swiper-city">{{item.city}}</p>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="playbtn-mb">
      <div class="swiper-button-prev" slot="button-prev">
        <img src="../../assets/imgs/dedeauto/icon_left.png">
      </div>
      <div class="swiper_play" ref="playorstop" @click="stop">
        <img src="../../assets/imgs/dedeauto/icon_stop.png" v-show="btnplay===true">
        <img src="../../assets/imgs/dedeauto/icon_play.png" v-show="btnplay===false">
      </div>
      <div class="swiper-button-next" slot="button-next">
        <img src="../../assets/imgs/dedeauto/icon_right.png">
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  props: {
    fugaiswipered: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      // tab切换
      // tabCheck: '已覆盖',
      //点击播放暂停按钮
      btnplay: true, //默认播放

      //swiper轮播
      swiperOption: {
        loop: true, //开启循环模式
        // speed: 2000,
        slidesPerView: 3, //设置slider容器能够同时显示的slides数量(carousel模式)
        spaceBetween: 20,
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        //自动轮播
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
      },
    };
  },
  components: {
    swiper,
    swiperSlide,
  },

  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    this.swiper.slideTo(3, 1000, false);
  },
  methods: {
    stop() {
      //通过调用鼠标移入移除间接实现暂停播放
      this.btnplay = !this.btnplay;
      this.btnplay ? this.on_bot_leave() : this.on_bot_enter();
    },

    on_bot_enter() {
      this.swiper.autoplay.stop();
    },
    on_bot_leave() {
      this.swiper.autoplay.start();
    },
  },
};
</script>

<style scoped>
.swiper-button-next,
.swiper-button-prev {
  position: static;
  margin: 0 10px;
  top: auto;
}
</style>
<style lang="scss" scoped>
.fugaiswipermain-mb {
  .swiper-slide-mb {
    position: relative;
    width: 782px !important;
    height: 782px;
  }
  .swiper-address-mb {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    .swiper-province,
    .swiper-city {
      color: #ffffff;
    }
    .swiper-province {
      font-size: 57px;
      font-weight: 400;
      margin-bottom: 71px;
    }

    .swiper-city {
      font-size: 128px;
      font-weight: 500;
    }
  }
  .playbtn-mb {
    text-align: center;
    display: flex;
    justify-content: center;
    margin-top: 178px;
    .swiper-button-prev,
    .swiper-button-next,
    .swiper_play {
      width: 178px !important;
      height: 178px !important;
      background: #ffffff;
      border: 4px solid #dcdcde;
      border-radius: 50%;
      background: none !important;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 27px;
        height: 47px;
        background: none;
      }
    }
    .swiper_play {
      border: none;
      img {
        width: 36px;
        height: 64px;
      }
    }
  }
}
</style>